<template>
  <div class="contactus-form-comp form-base">
    <section class="form-base-block">
      <div class="form-base-innerblock">

        <h1>{{ $t('contact-page.submit-request-title') }}</h1>

        <label for="">{{ $t('contact-page.your-email-title') }}</label>

        <form class="form-form" name="Text-form" data-name="Text Form">
          <input type="text" class="form-input" placeholder="" maxlength="256" name="" required="">
        </form>

        <label for="">{{ $t('contact-page.subject-title') }}</label>
        <form class="form-form" name="email-form" data-name="Email Form">
          <input type="email" class="form-input" placeholder="" maxlength="256" name="" required="">
        </form>

        <label for="">{{ $t('contact-page.description-title') }}</label>

        <textarea class="form-input form-text" name="Text Area" placeholder="" maxlength="5000"></textarea>

        <p class="description-hint" id="request_description_hint">{{ $t('contact-page.description-hint-text') }}</p>

        <label for="request-attachments">{{ $t('contact-page.attachments-title') }}</label>

        <div id="upload-dropzone" class="upload-dropzone form-input">
          <input class="" type="file" multiple="true" id="request-attachments" data-fileupload="true"
                 data-dropzone="upload-dropzone" data-error="upload-error" data-create-url="/hc/en-us/request_uploads"
                 data-name="request[attachments][]" data-pool="request-attachments-pool" data-delete-confirm-msg=""
                 aria-describedby="upload-error">
          <span><a class="s-text-blue">{{ $t('contact-page.add-file-link') }}</a> {{ $t('contact-page.drop-files-here-text') }}</span>
        </div>

        <div id="upload-error" class="notification notification-error notification-inline" style="display: none;">
          <span data-upload-error-message=""></span>
        </div>


        <ul id="request-attachments-pool" class="upload-pool" data-template="upload-template"></ul>

        <!--          <script type="text/html" id="upload-template">-->
        <!--            <li class="upload-item" data-upload-item>-->
        <!--              <a class="upload-link" target="_blank" data-upload-link></a>-->
        <!--              <p class="upload-path" data-upload-path></p>-->
        <!--              <p class="upload-path" data-upload-size></p>-->
        <!--              <p data-upload-issue class="notification notification-alert notification-inline" aria-hidden="true"></p>-->
        <!--              <span class="upload-remove" data-upload-remove></span>-->
        <!--              <div class="upload-progress" data-upload-progress></div>-->
        <!--              <input type="hidden">-->
        <!--            </li>-->
        <!--          </script>-->



        <s-button class="button-primary-blue s-button-round" btn-link="/">{{$t('actions.submit')}}</s-button>

      </div>
    </section>
  </div>

</template>
<script>
import SButton from "@/components/SButton.vue";

export default {
  components: {
    SButton,
  },
  props: {
    msg: String
  }
}
</script>

<style scoped lang="scss">

.hr-grey {
  width: 100%;
  margin: 20px 0;
}

.button-primary-blue {
  text-align: center;
  width: 100%;
}

.button-secondary {
  text-align: center;
  width: 100%;
  text-shadow: 0 0 0 #1B9EFF;
}

.form-base {
  height: auto;
  padding: 70px 0;
  display: flex;
  justify-content: center;
}

.form-base-block {
  height: auto;
  min-height: 600px;
  margin: 20px;
  width: 450px;
  font: inherit;
}

.form-base-innerblock {
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
  margin: auto auto;

  h1 {
    font-size: 52px;
    margin: 0;
    padding: 0 0 5px 0;
    text-align: center;
  }

  h4 {
    align-items: center;
    font-size: 18px;
    margin: auto;
    padding: 0 0 25px 0;
    text-align: center;
  }

  p {
    font-size: 15px;
    text-align: left;
    padding: 5px 0;
    margin: 0;
  }

  small {
    padding: 5px 0 0;
    text-align: center;
    display: block;
    font-size: 0.7em;

    & > a {
      text-decoration: none;
      color: #1B9EFF;
    }
  }
}

.form-base-side {
  height: auto;
  min-height: 600px;
  margin: 20px;
  font: inherit;
  background: none;
}

.form-base-details {
  padding: 30px 0;

  address {

    font-style: inherit;
  }
}

.form-form {
  padding: 0 0 10px;

}

.form-text {
  min-height: 200px;
}

.s-button-link {
  margin: auto 0 30px;
}

</style>
